import { NgModule } from '@angular/core';
import { SliderModule } from 'primeng/slider';
import { ToolbarModule } from 'primeng/toolbar';
import { InputTextModule } from 'primeng/inputtext';
import { CardModule } from 'primeng/card';
import { ButtonModule } from 'primeng/button';
import { FloatLabelModule } from 'primeng/floatlabel';
import { PasswordModule } from 'primeng/password';

import { TooltipModule } from 'primeng/tooltip';
import { ToastModule } from 'primeng/toast';
import { MessageService } from 'primeng/api';
import { PanelModule } from 'primeng/panel';

import { FieldsetModule } from 'primeng/fieldset';
import { TableModule } from 'primeng/table';
import { MenuModule } from 'primeng/menu';

import { InputNumberModule } from 'primeng/inputnumber';
import { CalendarModule } from 'primeng/calendar';
import { BadgeModule } from 'primeng/badge';

import { DialogModule } from 'primeng/dialog';
import { FileUploadModule } from 'primeng/fileupload';

import { TagModule } from 'primeng/tag';
import { ConfirmDialogModule } from 'primeng/confirmdialog';

import { ChipModule } from 'primeng/chip';



@NgModule({
  imports: [
    ButtonModule,
    SliderModule,
    ToolbarModule,
    InputTextModule,
    CardModule,
    FloatLabelModule,
    PasswordModule,
    TooltipModule,
    ToastModule,
    PanelModule,
    FieldsetModule,
    TableModule,
    MenuModule,
    InputNumberModule,
    CalendarModule,
    BadgeModule,
    DialogModule,
    FileUploadModule,
    TagModule,
    ConfirmDialogModule,
    ChipModule
  ],
  exports: [
    ButtonModule,
    SliderModule,
    ToolbarModule,
    InputTextModule,
    CardModule,
    FloatLabelModule,
    PasswordModule,
    TooltipModule,
    ToastModule,
    PanelModule,
    FieldsetModule,
    TableModule,
    MenuModule,
    InputNumberModule,
    CalendarModule,
    BadgeModule,
    DialogModule,
    FileUploadModule,
    TagModule,
    ConfirmDialogModule,
    ChipModule

  ],
  providers: [MessageService],
})
export class SharedPrimeNgModule { }
